<template>
  <div class="courseArranging">
    <div class="section">
      <el-page-header @back="goBack" content="分配学员"> </el-page-header>
      <el-row>
        <el-col :span="24"
          ><div>
            <el-tooltip
              class="item"
              effect="dark"
              content="从所有正式学员里,选择入班学员"
              placement="bottom-start"
            >
              <el-button
                style="margin-top: 20px"
                class="arrang_btn"
                type="primary"
                size="mini"
                @click="AddMoreStudent"
                >添加学员<i class="el-icon-question el-icon--right"></i
              ></el-button>
            </el-tooltip>

            <el-tooltip
              class="item"
              effect="dark"
              content="从已报名该课程的学员里,选择入班学员."
              placement="top-start"
            >
              <el-button
                style="margin-top: 20px"
                class="arrang_btn"
                type="primary"
                size="mini"
                @click="ChooseHasBuyStu"
                >添加已缴费学员<i class="el-icon-question el-icon--right"></i
              ></el-button>
            </el-tooltip>

            <el-tooltip
              class="item"
              effect="dark"
              content="学员移除班级后,未上讲次会被删除,谨慎操作"
              placement="top-start"
            >
              <el-button
                style="margin-top: 20px"
                size="mini"
                plain
                @click="delStudentClassRelation"
                >移除学员<i class="el-icon-question el-icon--right"></i
              ></el-button>
            </el-tooltip></div
        ></el-col>
      </el-row>

      <div class="table-style">
        <el-table
          size="mini"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          @selection-change="handleSelectionOutClassStudent"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column fixed="left" type="selection" width="55">
          </el-table-column>
          <el-table-column fixed="left" label="姓名">
            <template slot-scope="scope">
              <span>
                {{ scope.row.studentInfo.studentUserInfo.realname }}
              </span>
              <span style="color: #e6a23c" v-if="!scope.row.is_vaild">
                (已出班)
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="studentInfo.name" label="账号">
          </el-table-column>
          <el-table-column
            prop="studentInfo.studentUserInfo.sex"
            label="性别"
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column prop="in_class_date" label="入班日期">
          </el-table-column>

          <el-table-column prop="out_class_date" label="出班日期">
          </el-table-column>

          <el-table-column
            label="操作"
            fixed="right"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                :disabled="!scope.row.is_vaild"
                @click="getClassListForStuChangeClass(scope.row)"
                >调班</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-style">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="page_no"
            layout="total, prev, pager, next"
            :page-size="page_size"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>

    <!--学员分班-->
    <el-dialog
      width="80%"
      title="已缴费未入班学员"
      :visible.sync="dialogFormVisible2"
    >
      <el-row>
        <el-col :span="24"
          ><div class="grid-content bg-purple">
            <el-table
              size="mini"
              ref="multipleTable"
              :data="tableData2"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionNoClassStudent"
              :header-cell-style="{ background: '#f5f7fa' }"
            >
              <el-table-column fixed="left" type="selection" width="55">
              </el-table-column>
              <el-table-column label="姓名">
                <template slot-scope="scope">{{
                  scope.row.studentUserInfo.realname
                }}</template>
              </el-table-column>

              <el-table-column label="平台账号">
                <template slot-scope="scope">{{ scope.row.name }}</template>
              </el-table-column>

              <el-table-column label="选择收据" align="left">
                <template slot-scope="scope">
                  <el-select
                    size="mini"
                    v-model="tableData2[scope.$index].ClassGoodsInfo"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item of scope.row.stuClassGoodsInfoArr"
                      :key="item.id"
                      :label="
                        (Array(7).join(0) + item.receiptInfo.num).slice(-7)
                      "
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column label="关联状态" align="center">
                <template slot-scope="scope">
                  <span
                    v-if="tableData2[scope.$index].ClassGoodsInfo"
                    style="cursor: pointer; color: #409eff"
                    @click="
                      LookReceipt(
                        tableData2[scope.$index].ClassGoodsInfo.receiptInfo
                      )
                    "
                    >查看</span
                  >
                  <span v-else>未关联</span>
                </template>
              </el-table-column>
            </el-table>

            <!--TODO 已报名学员 分页-->
            <div class="pagination-style">
              <el-pagination
                @current-change="handleCurrentChange2"
                :current-page.sync="page_no2"
                layout="total, prev, pager, next"
                :page-size="page_size2"
                :total="total2"
              ></el-pagination>
            </div></div
        ></el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible2 = false"
          >取消</el-button
        >
        <el-button size="small" type="primary" @click="addStudentClassRelation"
          >添加</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="全部正式学员"
      :visible.sync="dialogTableVisible"
      width="80%"
      top="5vh"
    >
      <el-row :gutter="40">
        <el-col :span="14"
          ><div>
            <el-form :inline="true" size="mini" @submit.native.prevent>
              <el-form-item label="姓名">
                <el-input
                  style="width: 250px"
                  v-model="form3.realname"
                  placeholder="请输入学员姓名"
                  @keyup.enter.native="search3"
                ></el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="search3">查询</el-button>
              </el-form-item>
            </el-form>

            <div class="table-style">
              <el-table
                style="border: 1px solid #f5f7fa"
                size="mini"
                :data="gridData"
                :header-cell-style="{ background: '#f5f7fa' }"
              >
                <el-table-column
                  fixed="left"
                  width="100"
                  label="姓名"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.studentUserInfo.realname }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  width="150"
                  align="left"
                  prop="name"
                  label="账号"
                ></el-table-column>

                <el-table-column
                  width="50"
                  align="center"
                  prop="sex"
                  label="性别"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.studentUserInfo.sex }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  align="left"
                  label="所在班级"
                  width="300"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <div v-for="item in scope.row.stuClassArr" :key="item.id">
                      <span>{{ item.classInfo.name }}</span>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  fixed="right"
                  align="center"
                  label="操作"
                  width="100"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="text"
                      @click="InsertStudent(scope.$index)"
                      >选择
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination-style">
              <el-pagination
                @current-change="handleCurrentChange3"
                :current-page="page_no3"
                :page-size="page_size3"
                layout="total, prev, pager, next, jumper"
                :total="total3"
              >
              </el-pagination>
            </div></div
        ></el-col>
        <el-col :span="10"
          ><div>
            <div>已选学员</div>
            <div>
              <el-table
                size="mini"
                :data="gridData2"
                style="width: 100%; margin-top: 25px; border: 1px solid #f5f7fa"
                :header-cell-style="{ background: '#f5f7fa' }"
              >
                <el-table-column label="姓名" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.studentUserInfo.realname }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="studentUserInfo.sex"
                  label="性别"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="name" label="账号" align="center">
                </el-table-column>

                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" @click="Deleteoutputs(scope.$index)"
                      >移除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div></el-col
        >
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="CancelAdd">暂不添加</el-button>
        <el-button
          size="small"
          type="primary"
          @click="addStudentClassRelationFromAll"
          >加入班级</el-button
        >
      </span>
    </el-dialog>

    <el-dialog width="80%" title="选择目标班级" :visible.sync="outerVisible2">
      <el-form size="mini" :inline="true" :model="changeform" ref="ruleForm">
        <el-form-item label="班级名称">
          <el-input
            style="width: 250px"
            clearable
            v-model="changeform.className"
            placeholder="请输入班级名称"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search1" icon="el-icon-search"
            >查询
          </el-button>
        </el-form-item>
      </el-form>

      <div>
        <el-table
          size="mini"
          :data="stuChange_ClassList"
          style="width: 100%"
          highlight-current-row
          @current-change="SelectTargetClass"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column
            align="center"
            prop="name"
            label="班级名称"
          ></el-table-column>

          <el-table-column align="center" prop="start_date" label="开课日期">
          </el-table-column>

          <el-table-column align="center" prop="end_date" label="结课日期">
          </el-table-column>

          <el-table-column align="center" label="授课时段">
            <template slot-scope="scope">
              <span>{{ scope.row.week_str }} / {{ scope.row.time_str }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="上课进度">
            <template slot-scope="scope">
              <span
                >{{ scope.row.sign_tchplan_num }} /
                {{ scope.row.total_tchplan_num }}</span
              >
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            prop="lectureName"
            label="上课老师"
          ></el-table-column>
        </el-table>

        <div style="margin-top: 20px; text-align: right">
          <el-pagination
            @current-change="handleCurrentChange4"
            :current-page="page_no4"
            :page-size="page_size4"
            layout="total,prev, pager, next"
            :total="total4"
          ></el-pagination>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="outerVisible2 = false">取消</el-button>
        <el-button size="small" type="primary" @click="changeStuClass"
          >确定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="收据信息"
      :visible.sync="DialogVisible"
      width="80%"
      top="10vh"
    >
      <div
        class="dialog-body"
        v-if="ReceiptData.length > 0"
        style="margin-bottom: 20px"
      >
        <el-table
          size="small"
          ref="classTable"
          :data="ReceiptData"
          tooltip-effect="dark"
          :header-cell-style="{ background: '#f1f7fe' }"
        >
          <el-table-column align="center" label="名称" width="200">
            <template slot-scope="scope">
              <span v-if="scope.row.type == '1'"
                >{{ scope.row.curriculumInfo.title }}
              </span>
              <span v-else-if="scope.row.type == '2'"
                >{{ scope.row.goodsInfo.name }}
              </span>
              <span v-else>未知</span>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            prop="subject_id"
            label="班级"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="original_unit_price"
            label="原价"
          >
          </el-table-column>

          <el-table-column
            align="center"
            prop="buy_num"
            label="数量"
          ></el-table-column>

          <el-table-column align="center" label="单位">
            <template slot-scope="scope">
              <span v-if="scope.row.type == '1'">次 </span>
              <span v-else-if="scope.row.type == '2'"
                >{{ scope.row.goodsInfo.unit }}
              </span>
              <span v-else>未知</span>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            prop="discount"
            label="折扣(%)"
          ></el-table-column>

          <el-table-column align="center" label="金额">
            <template slot-scope="scope">
              {{ scope.row.now_unit_price * scope.row.buy_num }}
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            prop="give_num"
            label="赠送数量"
          ></el-table-column>
        </el-table>
      </div>

      <el-row>
        <el-col :span="12"
          ><div>
            <div style="background: #f1f7fe; color: #606266; padding: 10px">
              <span style="margin-left: 5px">结算信息</span>
            </div>

            <el-row style="padding: 20px">
              <el-col :span="24"
                ><div class="grid-content bg-purple-dark">
                  <el-form
                    size="mini"
                    :model="Current_Receipt"
                    ref="ruleForm"
                    label-width="100px"
                    class="demo-ruleForm"
                    style="bold: 500"
                  >
                    <el-form-item label="合计金额">
                      <span>{{ Current_Receipt.total_amount }}</span>
                    </el-form-item>

                    <el-form-item label="直减优惠">
                      <span>{{ Current_Receipt.other_amount }}</span>
                    </el-form-item>

                    <el-form-item label="应交金额">
                      <span>{{
                        Current_Receipt.total_amount -
                        Current_Receipt.other_amount
                      }}</span>
                    </el-form-item>

                    <el-divider></el-divider>

                    <el-form-item label="使用电子钱包">
                      <span>{{ Current_Receipt.bullet_amount }}</span>
                    </el-form-item>

                    <el-form-item label="实交金额">
                      <span>{{ Current_Receipt.final_amount }}</span>
                    </el-form-item>

                    <el-form-item label="收款账户">
                      <div v-for="item of receiptAccountList" :key="item.id">
                        <span>{{ item.accountName }}</span>
                        <span style="margin-left: 10px">{{ item.amount }}</span>
                      </div>
                    </el-form-item>
                  </el-form>
                </div></el-col
              >
            </el-row>
          </div></el-col
        >
        <el-col :span="12">
          <div style="background: #f1f7fe; color: #606266; padding: 10px">
            <span style="margin-left: 5px">其他信息</span>
          </div>

          <el-row style="padding: 20px">
            <el-col :span="24"
              ><div class="grid-content bg-purple-dark">
                <el-form
                  size="mini"
                  :model="updateform"
                  ref="ruleForm"
                  label-width="100px"
                  class="demo-ruleForm"
                >
                  <el-form-item label="交费类型">
                    <el-select
                      size="mini"
                      v-model="updateform.charge_type"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in shouju_type"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="发票编号">
                    <el-input v-model="updateform.fapiao"></el-input>
                  </el-form-item>

                  <el-form-item label="业绩归属人">
                    <el-select
                      clearable
                      v-model="updateform.leader"
                      placeholder="请选择业绩归属人"
                    >
                      <el-option
                        v-for="item in user_list"
                        :key="item.id"
                        :label="item.realname"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="备注">
                    <el-input
                      type="textarea"
                      v-model="updateform.remark"
                    ></el-input>
                  </el-form-item>
                </el-form></div
            ></el-col>
          </el-row>

          <div></div
        ></el-col>
      </el-row>

      <div slot="footer" style="margin-top: 20px" class="dialog-footer">
        <el-button size="small" @click="DialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getClassStudentList,
  getNotDivideStudentList,
  addStudentClassRelation,
  getFormalStudentList,
  delStudentClassRelation,
  getClassListForStuChangeClass,
  changeStuClass,
  getReceiptChargeGoodsList,
  getReceiptAccountList,
  getCampusUserList,
} from "@/api/educational";

export default {
  name: "divide-class",

  data() {
    return {
      tableData: [], //在班学员
      page_no: 1,
      page_size: 20,
      total: 0,

      //已缴费学员
      dialogFormVisible2: false, //已缴费学员
      tableData2: [],
      page_no2: 1,
      page_size2: 20,
      total2: 0,
      NoClassStudents: [], //选择未入班学员
      studentDataArr: [],

      //添加更多学员
      dialogTableVisible: false,
      form3: {
        realname: "",
        leader: "",
        phone_a_num: "",
        normal_state: "",
      },
      gridData: [], //正式学员
      gridData2: [], //选择的正式学员
      page_no3: 1,
      page_size3: 10,
      total3: 0,

      //班级移除学员
      OutClassStudents: [],
      outstudentIds: [],

      //学员调班
      current_student: "",
      current_student_id: "",

      page_no4: 1,
      page_size4: 10,
      total4: 0,
      outerVisible2: false,
      stuChange_ClassList: [],
      changeform: {
        className: "",
      },
      target_change_class: {},

      //查看收据
      DialogVisible: false,
      updateform: {},
      ReceiptData: [],
      Current_Receipt: {},
      shouju_type: [
        {
          id: 1,
          name: "新增",
        },
        {
          id: 2,
          name: "扩科",
        },
        {
          id: 3,
          name: "续费",
        },
        {
          id: 4,
          name: "预存",
        },
      ],
      user_list: [],
      receiptAccountList: [],
    };
  },

  mounted() {
    this.getClassStudentList();
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "class-management",
      });
    },

    getClassStudentList() {
      getClassStudentList({
        classId: this.$route.query.id,
        realname: "",
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log("查询班级学员列表");
        console.log(res);
        this.tableData = res.studentList;
        this.total = res.total;
      });
    },

    //已报名未分班学员
    getNotDivideStudentList() {
      getNotDivideStudentList({
        classId: this.$route.query.id,
        realname: "",
        page_no: this.page_no2,
        page_size: this.page_size2,
      }).then((res) => {
        console.log("查询已报名未分班学员");
        console.log(res);
        this.tableData2 = res.studentList;

        this.total2 = res.total;
      });
    },

    Deleteoutputs(index) {
      this.gridData2.splice(index, 1);
    },

    //查看收据
    LookReceipt(row) {
      if (!row) {
        this.$message.warning("请关联收据，再查看.");
        return;
      }

      console.log("查看收费收据");

      this.getReceiptChargeGoodsList(row);
    },

    //查询收据商品
    getReceiptChargeGoodsList(row) {
      this.DialogVisible = true;
      console.log("查询收据详情");
      console.log(row);
      this.getCampusUserList();
      this.Current_Receipt = row;
      this.goods_and_course_price = 0;
      this.updateform.id = row.id;
      this.updateform.bill_code = row.bill_code;
      this.updateform.leader = row.leader;
      this.updateform.educational_institution_campus_id =
        row.educational_institution_campus_id;
      this.updateform.remark = row.remark;
      this.updateform.charge_type = row.charge_type;

      this.ReceiptData = [];
      getReceiptChargeGoodsList({
        receipt_id: row.id,
      }).then((res) => {
        console.log("查询收据对应的商品");
        console.log(res);
        this.ReceiptData = res.receiptChargeGoodsList;

        for (let k = 0; k < res.receiptChargeGoodsList.length; k++) {
          console.log(res.receiptChargeGoodsList[k].total_amount);
          this.goods_and_course_price =
            this.goods_and_course_price +
            res.receiptChargeGoodsList[k].total_amount;
        }
      });
      //查询收据对应的账号
      getReceiptAccountList({
        receipt_id: row.id,
      }).then((res) => {
        console.log("查询收据对应的账户");
        console.log(res);
        this.receiptAccountList = res.receiptAccountList;
      });
    },

    //获得校区员工列表
    getCampusUserList() {
      getCampusUserList({
        campusId: this.$store.state.user.selected_schools[0],
      }).then((res) => {
        console.log("获得学校用户列表");
        console.log(res);
        this.user_list = res.campusUserList;
      });
    },

    handleSelectionNoClassStudent(selection) {
      this.NoClassStudents = selection;
      console.log("已选未分班学员");
      console.log(this.NoClassStudents);
    },

    //添加学员进班
    addStudentClassRelation() {
      if (this.NoClassStudents.length == 0) {
        this.$message.warning("请选择入班学员");
        return;
      }

      this.studentDataArr = []; //清空学生ID组
      var studentData = {
        student_user_id: "",
        receiptGoodsId: "",
      };

      for (let k = 0; k < this.NoClassStudents.length; k++) {
        if (this.NoClassStudents[k].ClassGoodsInfo) {
          studentData = {
            student_user_id:
              this.NoClassStudents[k].ClassGoodsInfo.student_user_id,
            receiptGoodsId: this.NoClassStudents[k].ClassGoodsInfo.id,
          };
        } else {
          this.$message.warning("有学员未关联收据，请核对");
          return;
        }

        this.studentDataArr.push(studentData);
      }

      console.log("添加学员参数");
      console.log(this.studentDataArr);

      addStudentClassRelation({
        studentDataArr: JSON.stringify(this.studentDataArr),
        curriculum_class_id: this.$route.query.id,
      }).then((res) => {
        console.log("添加学员进班");
        console.log(res);
        if (res.is_create) {
          if (res.failarr.length == 0) {
            this.$message.success("入班成功");
          } else {
            for (let k = 0; k < res.failarr.length; k++) {
              this.$notify({
                title: "警告:",
                message: res.failarr[k].failReason,
                type: "warning",
                duration: 2000,
                offset: k * 100 + 100,
              });
            }
          }
          this.getClassStudentList();
          this.getNotDivideStudentList();
        }
      });
    },

    ChooseHasBuyStu() {
      this.getNotDivideStudentList();
      this.dialogFormVisible2 = true;
    },

    //加入更多学员
    AddMoreStudent() {
      console.log("加入更多学员");
      this.dialogTableVisible = true;
      this.getFormalStudentList();
    },

    //查询所有正式学员
    getFormalStudentList() {
      getFormalStudentList({
        realname: this.form3.realname,
        leader: this.form3.leader,
        phone_a_num: this.form3.phone_a_num,
        normal_state: "2",
        campusIds: JSON.stringify([this.$route.query.campus_id]),
        page_no: this.page_no3,
        page_size: this.page_size3,
      }).then((res) => {
        console.log("查询所有正式学员");
        console.log(res);
        this.gridData = res.studentList;
        this.total3 = res.total;
      });
    },

    InsertStudent(index) {
      console.log("插入学员");
      console.log(index);
      this.gridData2.push(this.gridData[index]);

      this.gridData2 = this.unique(this.gridData2);
      console.log(this.gridData2);
    },

    //数组对象去重
    unique(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
    },
    handleCurrentChange2(val) {
      this.page_no2 = val;
      this.getNotDivideStudentList();
    },

    handleCurrentChange(val) {
      this.page_no = val;
      this.getClassStudentList();
    },

    handleCurrentChange3(val) {
      this.page_no3 = val;
      this.getFormalStudentList();
    },

    search3() {
      this.page_no3 = 1;
      this.getFormalStudentList();
    },

    //从全部学员加入班级
    addStudentClassRelationFromAll() {
      console.log("加入班级");
      console.log(this.gridData2);

      this.studentDataArr = []; //清空学生ID组
      var studentData = {
        student_user_id: "",
      };

      if (this.gridData2.length == 0) {
        this.$message.warning("请选择学员");
        return;
      }

      for (let k = 0; k < this.gridData2.length; k++) {
        studentData = {
          student_user_id: this.gridData2[k].id,
        };

        this.studentDataArr.push(studentData);
      }

      addStudentClassRelation({
        studentDataArr: JSON.stringify(this.studentDataArr),
        if_add_receipt_info: "0",
        curriculum_class_id: this.$route.query.id,
      }).then((res) => {
        console.log("添加学员进班");
        console.log(res);
        if (res.is_create) {
          if (res.failarr.length == 0) {
            this.$message.success("入班成功");
            this.dialogTableVisible = false;
          } else {
            for (let k = 0; k < res.failarr.length; k++) {
              this.$notify({
                title: "警告:",
                message:
                  this.gridData2[k].studentUserInfo.realname +
                  "," +
                  res.failarr[k].failReason,
                type: "warning",
                duration: 2000,
                offset: k * 100 + 100,
              });
            }
          }
          this.getClassStudentList();
        }
      });
    },

    CancelAdd() {
      this.dialogTableVisible = false;
      this.gridData2 = [];
    },

    //班级移除学员
    delStudentClassRelation() {
      if (this.OutClassStudents.length == 0) {
        this.$message.warning("请选择要移除的学员");
        return;
      }

      console.log(this.OutClassStudents);

      this.$confirm(
        "确定要移除所选学员吗? 移除后学员所有已分配讲次清空，且本操作不可逆。",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.outstudentIds = []; //清空学生ID组
        for (let k = 0; k < this.OutClassStudents.length; k++) {
          this.outstudentIds.push(this.OutClassStudents[k].studentInfo.id);
        }
        console.log("移除学员参数");
        console.log(this.outstudentIds);

        delStudentClassRelation({
          studentIds: JSON.stringify(this.outstudentIds),
          curriculum_class_id: this.$route.query.id,
        }).then((res) => {
          console.log("班级移除学员");
          console.log(res);
          if (res.is_delete) {
            if (res.failArr.length == 0) {
              this.$message.success("移除成功");
            } else {
              for (let k = 0; k < res.failArr.length; k++) {
                this.$notify({
                  title: "警告:",
                  message:
                    this.OutClassStudents[k].studentInfo.studentUserInfo
                      .realname +
                    "," +
                    res.failArr[k].msg,
                  type: "warning",
                  duration: 4000,
                  offset: k * 100 + 100,
                });
              }
            }

            this.getClassStudentList();
            this.getNotDivideStudentList();
          }
        });
      });
    },

    //移除班级的学员
    handleSelectionOutClassStudent(selection) {
      this.OutClassStudents = selection;
      console.log("已选即将移除班级的学员");
      console.log(this.OutClassStudents);
    },

    //可调入班级列表
    getClassListForStuChangeClass(row) {
      console.log("调班学员");

      console.log(row);
      this.current_student = row;
      this.current_student_id = row.student_user_id;

      getClassListForStuChangeClass({
        educational_institution_campus_id: this.$route.query.campus_id,
        curriculum_id: this.$route.query.curriculum_id,
        now_class_id: this.$route.query.id,
        className: this.changeform.className,
        lecturer_id: "",
        page_no: this.page_no4,
        page_size: this.page_size4,
      }).then((res) => {
        console.log("查询可调入班级");
        console.log(res);
        this.outerVisible2 = true;
        this.stuChange_ClassList = res.classList;
        this.total4 = res.total;
      });
    },

    handleCurrentChange4(val) {
      this.page_no4 = val;
      this.getClassListForStuChangeClass(this.current_student);
    },

    search1() {
      this.page_no4 = 1;
      this.getClassListForStuChangeClass(this.current_student);
    },

    //目标调入班级选择
    SelectTargetClass(val) {
      console.log("选择了目标调入班级");
      console.log(val);
      this.target_change_class = val;
    },

    //调班接口
    changeStuClass() {
      console.log("调班操作");
      changeStuClass({
        student_user_id: this.current_student_id,
        now_class_id: this.$route.query.id,
        change_class_id: this.target_change_class.id,
      }).then((res) => {
        console.log("调班接口");
        console.log(res);
        if (res.is_change) {
          this.$message.success("调班成功");
          this.outerVisible2 = false;
          this.getClassStudentList();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.courseArranging {
  .section {
    box-sizing: border-box;
    margin: 10px;
    padding: 15px 15px 15px 15px;
    border-radius: 5px;
    background-color: #fff;

    .arrang_btn {
      margin-bottom: 20px;
    }

    .classdate {
      margin-top: 20px;
      .classdate_start {
        font-weight: 500;
      }
      .classdate_stop {
        font-weight: 500;
      }
    }
    .hint {
      margin-left: 30px;
      font-size: 14px;
      color: red;
    }
    .time-frame {
      background-color: #f7f8fa;
      margin: 20px 0 0 20px;
      padding: 20px 0;
      border-radius: 5px;
      .frame {
        display: flex;
        align-items: center;
        border-radius: 5px;
        .title {
          font-size: 14px;
          margin-left: 20px;
        }
        .time {
          margin-left: 20px;
        }
      }
    }
    .btn {
      margin: 20px 0 0 20px;
    }

    .dialog {
      padding-bottom: 20px;
    }
  }
}
</style>
